export default "__VITE_PUBLIC_ASSET__f21b9d19__"